import React from "react";
import LegacyOrdersPage from "../../../ops/pages/orders-legacy";
import { buildSalesOrderColumns } from "./columns";
import { COLUMN_GROUPS, ALL_HIDEABLE_IDS, loadHiddenColumns, saveHiddenColumns } from "./columnPrefs";

/**
 * /v2/sales/orders.
 *
 */
function SalesOrdersPage() {
    return (
        <LegacyOrdersPage
            extraColumns={buildSalesOrderColumns}
            includeFinance
            functionalityKey="SALES_ORDERS"
            columnGroups={COLUMN_GROUPS}
            hideableIds={ALL_HIDEABLE_IDS}
            loadHidden={loadHiddenColumns}
            saveHidden={saveHiddenColumns}
        />
    );
}

export default SalesOrdersPage;
